<template>
  <v-card class="pa-0">
    <div style="align-items: center;" class="pa-4 d-flex justify-space-between align-center">
      <h3 class="primary--text mb-0">Select Section Template</h3>
      <div>
        <v-text-field
          placeholder="Search template"
          :hide-details="true"
          prepend-inner-icon="mdi-magnify"
          @input="e => handleSearchTemplate(e)"
          @clear="handleSearchTemplate('')"
        />
      </div>
      <v-btn icon @click="handleCloseModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider />
    <v-row>
      <v-col cols="12" md="2">
        <div class="category-templates">
          <v-list>
            <template v-for="item in categoryTpl">
              <v-list-group
                v-if="item.items && item.items.length"
                :key="item.title"
                :value="activeGroup === item.title"
                :prepend-icon="item.action"
                no-action
                @click="toggleGroup(item)"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="child in item.items"
                  :key="child.title"
                  :input-value="activeItem === child.title"
                  @click="handleSelectCategory(child)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="child.title" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <!-- for item not have children -->
              <v-list-item
                v-else
                :key="item.title + Math.random()"
                :input-value="activeItem === item.title"
                @click="handleSelectCategory(item)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </div>
      </v-col>
      <v-col cols="12" md="10">
        <div class="section-templates">
          <v-tooltip v-for="(template, index) in templates" :key="index" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="section-template-item" v-bind="attrs" v-on="on" @click="selectTemplate(template)">
                <div>
                  <img loading="lazy" :src="template.image" alt="" />
                </div>
              </div>
            </template>
            <span>Click to select</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>

    <div class="footer-section-templates">
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text outlined @click="handleCloseModal">Cancel</v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import templateSelection from '../common/mixins/template-selection';
import { handleSectionTemplate } from '../common/utils';
import { TplType } from '../common/mixins/template-selection';

export default {
  name: 'SelectSectionTemplate',
  mixins: [templateSelection],

  props: {
    typeInsert: {
      type: String,
      default: 'body',
    },
  },
  data() {
    return {
      TplType,
      templates: [],

      selectedTemplate: null,
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit('close');
    },
    handleSelectCategory(item) {
      this.activeItem = item.title;
      if (item.title === 'All templates') {
        this.templates = [...this.sectionTemplates];
        //remove active
        this.categoryTpl.forEach(item => {
          item.active = false;
        });
      } else {
        this.templates = this.sectionTemplates.filter(template => template.tplType === item.tplType);
      }
    },
    toggleGroup(item) {
      console.log(item);
      // this.activeGroup = this.activeGroup === item.title ? null : item.title
    },
    selectTemplate(template) {
      this.handleSelectTemplate(template);
    },
    handleSelectTemplate(template) {
      const templateNewId = handleSectionTemplate.insertNewId(template);
      this.$emit('select', templateNewId, this.typeInsert);
      this.$emit('close');
    },
    handleSearchTemplate(value) {
      this.templates = this.sectionTemplates.filter(template =>
        template.title.toLowerCase().includes(value.toLowerCase()),
      );
      if (value === '') {
        this.templates = [...this.sectionTemplates];
      }
    },
  },
  created() {
    this.templates = [...this.sectionTemplates];
    if (this.typeInsert === 'footer') {
      this.handleSelectCategory({ title: 'Basic Footer', tplType: TplType.Footer });
    }
  },
  watch: {
    typeInsert: {
      handler(val) {
        if (val === 'footer') {
          this.handleSelectCategory({ title: 'Basic Footer', tplType: TplType.Footer });
        } else {
          this.handleSelectCategory({ title: 'All templates', tplType: TplType.Section });
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.category-templates {
  // border-right: solid 1px #c1c1c1;
  @media (min-width: 1024px) {
    overflow-y: auto;
    max-height: calc(100vh - 68px - 68px - 5px);
  }
}
.section-templates {
  max-height: calc(100vh - 68px - 68px - 5px);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  padding: 30px;
}

.section-template-item {
  width: calc((100% - 24px) / 3);
  border-color: var(--v-primary-base);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  min-height: 226px;

  &:hover {
    border-color: var(--v-primary-base);
    background-color: #f5f5f5;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.footer-section-templates {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}

.template-icon {
  margin-right: 16px;
  flex-shrink: 0;
}

.template-content {
  flex: 1;
}

.template-title {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.template-description {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.template-arrow {
  flex-shrink: 0;
}

.v-list-item--link:before {
  background-color: aqua;
}
.v-list-item--active {
  color: #0081c7;
}
</style>
